import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {GruendungsformAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-gruendungsform-angaben',
  templateUrl: './gruendungsform-angaben.component.html'
})
export class GruendungsformAngabenComponent extends WizardPageBaseComponent<GruendungsformAngaben> {

  static nutzdatenPath = 'gruendungsformAngaben';
  static route = 'gruendungsform-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
